import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Group } from '@libs/src/models/group.model';

@Component({
  selector: 'app-profile-completion-widget',
  templateUrl: './profile-completion-widget.component.html',
})
export class ProfileCompletionWidgetComponent {
  @Input() canSkip: boolean;
  @Input() ctaText: string;
  @Input() description: string;
  @Input() group: Group;
  @Input() profileStrengthCount: number;
  @Input() profileStrengthText: string;
  @Input() stepsToCompletion: number;
  @Input() title: string;
  @Output() addProfileInformation = new EventEmitter();
  @Output() skip = new EventEmitter();
}
